var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: _vm.title,
        width: "696px",
        loading: _vm.loading,
        "show-close": false,
        height: "auto",
        "append-to-body": true,
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "chatRecords" }, [
        _c("div", { staticClass: "tTable" }, [
          _c("div", { staticClass: "tHeader" }, [
            _c("div", { staticClass: "table_column" }, [
              _c("div", { staticClass: "cell" }, [_vm._v("发言时间")]),
            ]),
            _c("div", { staticClass: "table_column" }, [
              _c("div", { staticClass: "cell" }, [_vm._v("发言内容")]),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.load,
                  expression: "load",
                },
              ],
              staticClass: "tBody",
              staticStyle: { overflow: "auto" },
              attrs: { "infinite-scroll-disabled": "disabled" },
            },
            [
              _vm._l(_vm.list, function (item, index) {
                return _c("div", { key: index, staticClass: "tableRow" }, [
                  _c("div", { staticClass: "table_column" }, [
                    _c("div", { staticClass: "cell" }, [
                      _vm._v(_vm._s(_vm._f("filterTime")(item.msgTime))),
                    ]),
                  ]),
                  _c("div", { staticClass: "table_column" }, [
                    _c(
                      "div",
                      { staticClass: "cell" },
                      [
                        [
                          item.msgBody &&
                          item.msgBody[0].msgType === "TIMTextElem" &&
                          item.msgBody[0].textMsgContent
                            ? _c("div", {
                                staticClass: "comment_content_text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.filterContent(
                                      item.msgBody[0].textMsgContent.text
                                    )
                                  ),
                                },
                              })
                            : item.msgBody &&
                              item.msgBody[0].msgType === "TIMImageElem" &&
                              item.msgBody[0].imageMsgContent.origImage
                            ? _c(
                                "div",
                                [
                                  _c("el-image", {
                                    style: {
                                      width: `${
                                        !item.msgBody[0].imageMsgContent
                                          .origImage.width
                                          ? 100
                                          : item.msgBody[0].imageMsgContent
                                              .origImage.width
                                      }px`,
                                      height: `${
                                        !item.msgBody[0].imageMsgContent
                                          .origImage.height
                                          ? 100
                                          : item.msgBody[0].imageMsgContent
                                              .origImage.height
                                      }px`,
                                      maxHeight: "100px",
                                      maxWidth: "100px",
                                    },
                                    attrs: {
                                      src: item.msgBody[0].imageMsgContent
                                        .origImage.url,
                                      fit: "contain",
                                      "preview-src-list": [
                                        item.msgBody[0].imageMsgContent
                                          .origImage.url,
                                      ],
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                      ],
                      2
                    ),
                  ]),
                ])
              }),
              _vm.list.length === 0
                ? _c("div", { staticClass: "noDataText" }, [
                    _c("div", { staticClass: "empty-text" }, [
                      _vm._v(" 暂无数据 "),
                    ]),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "div",
          { staticClass: "ss-material-box-bottom" },
          [
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.closeFn } },
              [_vm._v("取消")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "liveRoomTitle",
          attrs: { slot: "title" },
          slot: "title",
        },
        [_c("span", [_vm._v(_vm._s(_vm.liveRoomName))])]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }